import styles from './styles.scss';
import { SuggestedProduct } from 'models/SuggestedProduct';
import Price from 'components/Shared/Price';
import Image from 'components/Shared/Image';
import { BhImageType } from 'models/BhImageType';
import cn from 'classnames';
import { NotifyLink } from 'components/Shared/NotifyLink';

interface OwnProps {
  productData: SuggestedProduct;
  selected?: boolean;
  onSelect: () => void;
}

const PRODUCT_IMAGE_HEIGHT = 50;
const PRODUCT_IMAGE_WIDTH = PRODUCT_IMAGE_HEIGHT;

export default ({ productData, onSelect, selected }: OwnProps) => (
  <NotifyLink
    className={cn(styles.product, selected ? styles.selected : '')}
    url={productData.url}
    ticket={productData.ticket}
    onClick={onSelect}
  >
    <Image
      {...{
        type: BhImageType.Product,
        id: productData.imageGuid,
        name: productData.imageName,
        height: PRODUCT_IMAGE_HEIGHT,
        width: PRODUCT_IMAGE_WIDTH,
        className: styles.image,
        alt: productData.displayName
      }}
    />
    <span className={styles.name}>{productData.displayName}</span>
    <Price price={productData.listPrice} appearance="discount" className={styles.price} />
  </NotifyLink>
);
